const aboutUsData = [
    {
      name: "Travis Yogi Permana",
      img:"yogie",
      bio: "Technical PM with a UX background—accidentally into coding, unexpectedly loving it.",
      portfolio: "https://travisthalion.notion.site/Hi-I-m-Yogie-also-known-as-Travis-feedeecbffdf45aaa8209f13ccfdba4f",
    },
    {
      name: "Yung Yung",
      img:"yungyung",
      bio: "Define and implement technical solutions for the project direction, and visualization and user experience.",
      portfolio: "https://www.linkedin.com/in/yungy/", 
    },
    {
      name: "Yulu Zhang",
      img:"yulu",
      bio: "Passport pixie. Love to engage with people. UX researcher, enthonograpghy researcher & design activist for now.",
      portfolio: "https://yuluzhang777.myportfolio.com/",
    },
    {
      name: "Manato Chiba",
      img:"manato",
      bio: "Voyager from Japan. UI/UX Designer, Software-Engineer, Podcaster. Running on curiosity and random inspiration.",
      portfolio: "https://manato-chiba.surge.sh/",
    },
  ];
  
  export default aboutUsData;
  